import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/layout/PageShell";
import Container from "../components/primitives/Container";
import Section from "../components/primitives/Section";
import Eyebrow from "../components/primitives/Eyebrow";
import Reveal from "../components/primitives/Reveal";
import SeoHead from "../components/seo/SeoHead";

const NotFound = () => {
  return (
    <PageShell>
      <SeoHead title="Not Found" path="/" noIndex />
      <Section tone="light" className="pt-32 md:pt-40 lg:pt-44 pb-24">
        <Container>
          <Reveal className="max-w-2xl">
            <Eyebrow tone="muted">Error 404</Eyebrow>
            <h1
              className="mt-8 font-serif font-normal text-navy text-balance"
              data-testid="notfound-title"
              style={{ fontSize: "clamp(40px, 5.5vw, 80px)", lineHeight: 1.05, letterSpacing: "-0.01em" }}
            >
              Not Found.
            </h1>
            <span aria-hidden="true" className="mt-10 block h-px w-12 bg-gold" />
            <p className="mt-10 font-sans text-[16px] sm:text-[17px] leading-[1.75] text-navy/80 max-w-prose">
              The page you requested could not be located. It may have been moved, or it may not yet exist in this phase of the site.
            </p>
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="group mt-12 inline-flex items-center gap-3 font-sans uppercase text-navy"
              style={{ fontSize: "11px", letterSpacing: "0.22em" }}
            >
              <span className="relative">
                Return to Home
                <span
                  aria-hidden="true"
                  className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100"
                />
              </span>
              <span aria-hidden="true" className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
            </Link>
          </Reveal>
        </Container>
      </Section>
    </PageShell>
  );
};

export default NotFound;
